import {StripeProduct} from "../Models/StripeProduct";
import {UserTypeEnum} from "../enums/user-type.enum";
import {StripeProductsIdPreprodEnum, StripeProductsIdProdEnum} from "../enums/stripe-products-id.enum";
import {environment} from "../../environments/environment";
import {EnvironmentEnum} from "../enums/environment.enum";
import {SiteKeyEnum} from "../enums/site-key.enum";

export const StripeProductsList: StripeProduct[] = [
	{
		ProductId: getStripeProductsIdByEnv(environment.name).TARIF_UNIQUE_SELOGER,
		ProductName: "Tarif unique SeLoger > 1 estimation",
		showInRefs: [SiteKeyEnum.SELOGER],
		showInUserTypes: [UserTypeEnum.PARTICULIER]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).TARIF_UNIQUE,
		ProductName: "Tarif unique > 1 estimation",
		showInRefs: [SiteKeyEnum.LFIMMO],
		showInUserTypes: [UserTypeEnum.PARTICULIER]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).PACK_5_ESTIMATIONS,
		ProductName: "Pack de 5 estimations",
		showInRefs: [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.INNOVIA, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.WEINVESTAGENT, SiteKeyEnum.WEINVESTCLIENT, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV, SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL],
		showInUserTypes: [UserTypeEnum.PARTICULIER, UserTypeEnum.AGENT_MANDATAIRE, UserTypeEnum.AGENCE_VITRINE, UserTypeEnum.ENTREPRISE_BATIMENT]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_MENSUEL_ILLIMITE_AGENCE,
		ProductName: "Abonnement mensuel en illimité",
		showInRefs: [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.INNOVIA, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.CAPIFRANCE, SiteKeyEnum.OPTIMHOME, SiteKeyEnum.WEINVESTAGENT, SiteKeyEnum.WEINVESTCLIENT, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV, SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL],
		showInUserTypes: [UserTypeEnum.AGENCE_VITRINE, UserTypeEnum.ENTREPRISE_BATIMENT]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_MENSUEL_ILLIMITE_PARTICULIER,
		ProductName: "Abonnement mensuel en illimité",
		showInRefs: [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.INNOVIA, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.CAPIFRANCE, SiteKeyEnum.OPTIMHOME, SiteKeyEnum.WEINVESTAGENT, SiteKeyEnum.WEINVESTCLIENT, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV, SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL],
		showInUserTypes: [UserTypeEnum.PARTICULIER, UserTypeEnum.AGENT_MANDATAIRE]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_ANNUEL_ILLIMITE_AGENCE,
		ProductName: "Abonnement annuel à 299€ en Illimité",
		parentProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_MENSUEL_ILLIMITE_AGENCE,
		showInRefs: [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.INNOVIA, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.CAPIFRANCE, SiteKeyEnum.OPTIMHOME, SiteKeyEnum.WEINVESTAGENT, SiteKeyEnum.WEINVESTCLIENT, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV, SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL],
		showInUserTypes: [UserTypeEnum.AGENCE_VITRINE, UserTypeEnum.ENTREPRISE_BATIMENT]
	},
	{
		ProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_ANNUEL_ILLIMITE_PARTICULIER,
		ProductName: "AAbonnement annuel à 99€ en illimité",
		parentProductId: getStripeProductsIdByEnv(environment.name).ABONNEMENT_MENSUEL_ILLIMITE_PARTICULIER,
		showInRefs: [SiteKeyEnum.KOUTRAVO, SiteKeyEnum.LADRESSE, SiteKeyEnum.CADASTRE, SiteKeyEnum.KOUTRAVOFREE, SiteKeyEnum.INNOVIA, SiteKeyEnum.ARTHURIMMO, SiteKeyEnum.CAPIFRANCE, SiteKeyEnum.OPTIMHOME, SiteKeyEnum.WEINVESTAGENT, SiteKeyEnum.WEINVESTCLIENT, SiteKeyEnum.LOISELETDAIGREMONT, SiteKeyEnum.SOLALRENOV, SiteKeyEnum.AGENCEPLUS, SiteKeyEnum.LALOUPEIMMO, SiteKeyEnum.KTVEXTERNAL],
		showInUserTypes: [UserTypeEnum.PARTICULIER, UserTypeEnum.AGENT_MANDATAIRE]
	}
]

export function getStripeProductsIdByEnv(envName: string): typeof StripeProductsIdProdEnum | typeof StripeProductsIdPreprodEnum {
	if (envName === EnvironmentEnum.PROD) {
		return StripeProductsIdProdEnum;
	} else {
		return StripeProductsIdPreprodEnum;
	}
}
